






































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import FaqArticleDto from '@/models/FaqArticles/FaqArticleDto'
import FaqArticleCreate from '@/components/FaqArticles/FaqArticleCreate.vue';
import FaqArticleEdit from '@/components/FaqArticles/FaqArticleEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'FaqArticles',
  components: { FaqArticleEdit, FaqArticleCreate }
})
export default class extends GiganautVue {
    
    async beforeMount() {

    }

    async updateCurrentFaqArticle(faqArticle: FaqArticleDto) {
        AgencySettingsModule.updateCurrentFaqArticle(faqArticle);
    }

    get faqArticles() {
        return AgencySettingsModule.faqArticles;
    }

    get loading() {
        return AgencySettingsModule.loadingFaqArticles;
    }

    private search = '';

    async deleteFaqArticle(faqArticle: FaqArticleDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the faq article ' + faqArticle.title + '?', options);
        // if (result) {
        //     const request = new UpdateAgencyUserStatusRequest();
        //     request.updatedAt = user.updatedAt;
        //     request.status = AgencyUserStatusEnum.Deleted;
        //     await AgencySettingsModule.deleteAgencyUser(request);
        // }
  }

     private headers = [
    { text: "Title", value: 'title'},
    { text: 'Actions'},
  ]
}
